import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component({
  standalone: false,
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent {
  @Input() disabled = false
  @Input() value: any
  @Input() label = ''
  @Input() id = ''
  @Input() checked = false
  @Input() type: 'checkbox' | 'radio' = 'checkbox'
  @Input() toCheck: any[]
  @Input() values: any[]
  @Output() onChange = new EventEmitter<any>()
  @Output() onFill = new EventEmitter<any>()
  @Output() onEmpty = new EventEmitter<any>()

  constructor() {}

  change($event, val = null) {
    if (!this.disabled) {
      if (this.values !== undefined && val === null) {
        if (this.toCheck.length === this.values.length) {
          this.onEmpty.emit({})
        } else if (
          this.toCheck.length !== 0 &&
          this.toCheck.length !== this.values.length
        ) {
          this.onEmpty.emit({})
        } else {
          this.onFill.emit({})
        }
      }

      if (this.values !== undefined && val !== null) {
        this.onChange.emit({
          checked: this.toCheck.length !== this.values.length,
          value: val ? val : this.value,
          originalEvent: $event,
        })
      }

      if (this.values === undefined) {
        if (this.type === 'radio' && this.checked) {
          return
        }

        this.checked = !this.checked
        this.onChange.emit({
          checked: this.checked,
          value: this.value,
          originalEvent: $event,
        })
      }
    }
  }
}
